import actionCable from 'actioncable';
import appConfig from 'config';

const wsHost = `${appConfig.apiUrl.replace('http', 'ws')}/apis/v2/cable`;
const cable = actionCable.createConsumer(wsHost);

export default cable;
